import { render, staticRenderFns } from "./VehicleTrimAndVehicleOwnershipType.vue?vue&type=template&id=4b7511c4&scoped=true&"
import script from "./VehicleTrimAndVehicleOwnershipType.vue?vue&type=script&lang=js&"
export * from "./VehicleTrimAndVehicleOwnershipType.vue?vue&type=script&lang=js&"
import style0 from "./VehicleTrimAndVehicleOwnershipType.vue?vue&type=style&index=0&id=4b7511c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7511c4",
  null
  
)

export default component.exports